/* Helper functions */
import Flow from "./flow.service";
import Storage from "./storage.service";

var Errors = {};

// Helpers.generateDeviceID = () => {
// 	return Math.floor(Math.random() * 10000000000 + 1);
// };

Errors.getErrorCode = (error) => {
	if (error && error.response) {
		if (error.response.data.code) {
			return error.response.data.code;
		}
		if (error.response.data.error) {
			return error.response.data.error;
		}
		return error;
	}
	return true;
};

Errors.getErrorType = (code) => {
	let type = "error_general";
	switch (code) {
		case -175:
		case -176:
		case -177:
			type = "saving_plan_error";
			break;
		case -7109:
			type = "payment_error_failed";
			break;

		case -107:
			type = "login_credentials_error";
			break;

		case -7011:
			type = "payment_error_insufficient";
			break;

		case -10012:
			type = "payment_error_transaction_failed";
			break;

		case -7106:
			type = "payment_error_incorrect_details_temp_issue";
			break;

		case -7103:
			type = "payment_error_fraud";
			break;

		case -7105:
			type = "payment_error_incorrect_cvv";
			break;

		case -7110:
			type = "payment_error_transaction_declined";
			break;

		case -7108:
			type = "payment_error_incorrect_details";
			break;

		case -7099:
		case -7111:
		case -10001:
		case -10016:
		case -10013:
		case -10015:
		case -7100:
		case -7059:
		case -7101:
			type = "payment_error_general";
			break;

		case -2015:
			type = "number_already_booked";
			break;

		case -405:
			type = "number_in_transfer";
			break;

		case -440:
			type = "wrong_operator";
			break;

		case -434:
			type = "number_not_activated";
			break;

		case -401:
			type = "delivery_unsupported_for_area";
			break;

		case -128:
			type = "delivery_closed_for_area";
			break;

		case -2010:
			type = "number_expired";
			break;
		case -442:
			type = "installment_max_sim";
			break;
		case "non_eligible_card":
			type = "non_eligible_card";
			break;

		case "spotii_error":
			type = "spotii_error";
			break;

		case "non_recurring_card":
			type = "non_recurring_card";
			break;

		case -116: 
		type= "black_listed_sim_activation";
		break;
		
		case -10018:
			type= "under_age_sim_activation";
			break;

		case -169: 
		case -578:
		case -579:
		case -584:
			type= "max_sims_reached";
			break;

		case -606:
		case -608:
			type="retry_moi_scan";
			break;
			
		case -607:
		type="moi_api_failure"
		break;

		case -609:
			type="moi_subscriberid_mismatch";
			break;

		case -612:
		case -611:
			type="residents_not_allowed_for_passport_moi";
			break;

		case -614:
			type = "moi_error_residency_exists";
			break;

		case -615:
				type = "moi_error_expired_immigration_record";
				break;

		case -616:
				type = "moi_error_invalid_immigration_record";
				break;

		case -617:
				type = "moi_error_missmatched_person_identifier_expiry";
				break;

		case -618:
				type = "moi_error_expired_person_identifier";
				break;

		case -619:
				type = "moi_error_uncorrelated_person_identifiers";
				break;

		case -620:
				type = "moi_error_no_match";
				break;

		case -621:
				type = "moi_error_no_trusted_database_record_found";
				break;

		case -622:
				type = "moi_error_face_prints_appear_to_be_of_multiple_persons";
				break;

		case -623:
				type = "moi_error_no_trusted_person_identifier_found";
				break;

		case -624:
		case -625:
		case -626:
		case -627:
		case -628:
		case -629:
		case -630:
		case -631:
		case -632:
		case -633:
		case -634:
		case -635:
		case -636:
		case -637:
		case -638:
				type = "moi_error_invalid_id_details";
				break;

		case -639:
				type = "moi_error_expired_date";
				break;
		case -640:
				type = "moi_error_mismatched_date_of_birth";
				break;
		case -641:
				type = "moi_error_mismatched_gender";
				break;
		case -642:
				type = "moi_error_unsupported_image_format";
				break;
		case -643:
				type = "moi_error_unsuitable_portrait_image";
				break;
		case -644:
				type = "moi_error_image_too_large";
				break;
		case -645:
				type = "moi_error_mismatched_hash";
				break;
		case -646:
				type = "moi_error_unsupported_tag";
				break;

		default:
			type = "error_general";
			break;

		// case -200: // invalid Email
		// case -435: //Your Email Already Terminated.
	}
	return type;
};

Errors.handleHTTPError = (error = "error") => {

	let code = Errors.getErrorCode(error);
	let type = Errors.getErrorType(code);
  
	if (type === "call_login") {
	  // console.log("it's a credentials error.. yayyy");
	  if (!isNaN(code)) {
		Storage.set("error", code);
	  } else {
		Storage.set("error", type);
	  }
	}
  };
  
  Errors.handleError = (error = "error") => {
	let code = Errors.getErrorCode(error);
	let type = Errors.getErrorType(code);
    
	if(Storage.get("payment_error")){
	  Storage.clear("payment_error");
	  Flow.goTo(Flow.get("root_id"));
	}
  
	if(type === 'general_error'){
	  Flow.goTo(Flow.get("root_id"));
	}
  
	if(type !== "error_wrong_email_or_password"){
	  if (!isNaN(code)) {
		Storage.set("error", code);
	  } else {
		Storage.set("error", type);
	  }
	}
  };
export default Errors;